import {Api} from '../../../Api.js'

const RESOURCE = 'voucher-token'

export default {
    resource: RESOURCE,
    prefix: 'shop/',
    all(query) {
        return Api().get(this.prefix + this.resource + '/all'  + (query ? query : '') )
    },
    query(query) {
        return Api().get(this.prefix + this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.prefix + this.resource + '/' + id)
    },
}


// WEBPACK FOOTER //
// ./src/modules/shop/voucher/VoucherTokenService.js